import { render, staticRenderFns } from "./SitesBulkAdd.vue?vue&type=template&id=05838378"
import script from "./SitesBulkAdd.vue?vue&type=script&lang=ts"
export * from "./SitesBulkAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports